import React from 'react';
import {useSelector} from 'react-redux';
import {Store} from 'src/types/store';
import {calculateGpa} from 'shared/utils';
import GpaTooltip from 'shared/components/gpa-modal/tooltip';
import Icon from 'shared/components/icon';
import NewTabTooltip from 'shared/components/new-tab-tooltip';
import styles from './gpa-and-tips.module.scss';

const GpaAndTips = () => {
  const graduationYear = useSelector((state: Store) => state.student.highSchoolInfo.graduationYear);
  const courses = useSelector((state: Store) => state.bulkEntryCourses);
  const gpa = calculateGpa(courses, graduationYear);

  return (
    <div className={styles.container}>
      {gpa !== null && gpa !== undefined && (
        <>
          <span className={styles.gpa}>
            Raise Me GPA: &nbsp;
            <span className="shared-font bold">{gpa}</span>
            <GpaTooltip />
          </span>
          |
        </>
      )}
      <NewTabTooltip>
        <a
          href="https://help.raise.me/hc/en-us/sections/360000776773-Adding-Courses-to-your-Portfolio"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.tips}
        >
          <Icon iconType="lightbulb-r" className={styles.lightbulb} />
          Tips
        </a>
      </NewTabTooltip>
    </div>
  );
};

export default GpaAndTips;
